//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data: function () {
    return {
      swiperOptions: {
        slidesPerView: 1,

        centeredSlides: true,
        maxBackfaceHiddenSlides: 1,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination'
        },

        navigation: {
          prevEl: '.swiper__button-navigation--prev',
          nextEl: '.swiper__button-navigation--next'
        },
      },
    }
  },

  computed: {
    images: function () {
      return this.$store.state['swiper-popup']?.images;
    },
    activeIndex: function () {
      return this.$store.state['swiper-popup']?.activeIndex || '';
    },
    isOpen: function () {
      return this.$store.state["swiper-popup"]?.isOpenSwiperPopup || false;
    },

    buttonCloseComponent: function () {
      if (this.buttonCloseLink) {
        return "nuxt-link"
      }
      return "button"
    }
  },

  methods: {
    initSwiper: function () {
      const activeIndex = this.$store.state["swiper-popup"]?.activeIndex;
      if (activeIndex <= 0) {
        return
      }
      this.$refs.refSwiper?.$swiper.slideTo(activeIndex);
    },

    close: function () {
      this.$store.commit(
        "swiper-popup/closeSwiperPopup"
      )
    }
  },
  watch: {
    isOpen: function () {
      if (this.isOpen) {
        document.body.style.overflow = "hidden";
        return
      }

      document.body.style = "";
    }
  },
};
